{% block scop_platform_redirect_details %}
    <sw-page class="scop-platform-redirect-details">
        <template #smart-bar-actions>
            <sw-button size="default"
                       variant="secondary" :routerLink="{name: 'scop.platform.redirect.list'}">
                {{ $t('scopplatformredirecter.detail.cancelButton') }}</sw-button>
            <sw-button-process :isLoading="isLoading"
                               :processSuccess="processSuccess" variant="primary"
                               @update:processSuccess="saveFinish" @click="onClickSave">
                {{ $t('scopplatformredirecter.detail.saveButton') }}</sw-button-process>
        </template>
        <template #content>
            <sw-card-view>
                <sw-card v-if="redirect" :isLoading="isLoading">
                    {% block scop_platform_redirect_details_auto_created_banner %}
                        <mt-banner
                                v-if="redirect && redirect.productId"
                                variant="info"
                        >
                            {{ $tc('scopplatformredirecter.detail.autoCreatedInfo') }}
                            <router-link
                                    v-if="redirect.product"
                                    :to="{ name: 'sw.product.detail', params: { id: redirect.productId } }"
                            >
                                {{ redirect.product.translated ? redirect.product.translated.name : redirect.product.name }}
                            </router-link>
                        </mt-banner>
                    {% endblock %}
                    <sw-text-field :label="$t('scopplatformredirecter.detail.sourceUrlLabel')" v-model:value="redirect.sourceURL"
                              validation="required"></sw-text-field>

                    {% block scop_platform_redirect_details_target %}
                        <mt-banner
                                v-if="showIapLockedBanner"
                                variant="attention"
                                class="scop-platform-redirect-details__iap-banner"
                        >
                            <p>{{ $tc('scopplatformredirecter.detail.entityLinkIapRequired') }}</p>
                            <mt-button
                                    variant="primary"
                                    size="small"
                                    @click="onClickPurchase"
                            >
                                {{ $tc('scopplatformredirecter.detail.danglingEntity.purchaseButton') }}
                            </mt-button>
                            <mt-button
                                    variant="secondary"
                                    size="small"
                                    @click="onConvertDanglingToManual"
                            >
                                {{ $tc('scopplatformredirecter.detail.danglingEntity.convertToManual') }}
                            </mt-button>
                        </mt-banner>

                        <mt-banner
                                v-if="isEntityDangling && !showIapLockedBanner"
                                variant="critical"
                                class="scop-platform-redirect-details__dangling-banner"
                        >
                            <p>{{ $tc('scopplatformredirecter.detail.danglingEntity.' + redirect.targetEntityType) }}</p>
                            <mt-button
                                    variant="primary"
                                    size="small"
                                    @click="onConvertDanglingToManual"
                            >
                                {{ $tc('scopplatformredirecter.detail.danglingEntity.convertToManual') }}
                            </mt-button>
                        </mt-banner>

                        <template v-if="entityLookupDone && !isEntityDangling && !showIapLockedBanner">
                            <sw-single-select
                                    :label="$tc('scopplatformredirecter.detail.targetModeLabel')"
                                    :value="targetMode"
                                    :options="targetModeOptions"
                                    @update:value="onTargetModeChange"
                            />

                            <template v-if="targetMode === 'manual'">
                                <sw-text-field
                                        :label="$tc('scopplatformredirecter.detail.targetUrlLabel')"
                                        v-model:value="redirect.targetURL"
                                        validation="required"
                                />
                            </template>

                            <template v-if="targetMode === 'product'">
                                <sw-entity-single-select
                                        class="scop-platform-redirect-details__entity-select"
                                        :label="$tc('scopplatformredirecter.detail.targetEntity.product')"
                                        entity="product"
                                        :value="redirect.targetEntityId"
                                        @update:value="onEntityChange('product', $event)"
                                />
                                <p v-if="resolvedEntityUrl" class="scop-platform-redirect-details__entity-hint">
                                    {{ $tc('scopplatformredirecter.detail.resolvedSeoUrlHint') }}
                                    <code>{{ resolvedEntityUrl }}</code>
                                </p>
                            </template>

                            <template v-if="targetMode === 'category'">
                                <sw-entity-single-select
                                        class="scop-platform-redirect-details__entity-select"
                                        :label="$tc('scopplatformredirecter.detail.targetEntity.category')"
                                        entity="category"
                                        :value="redirect.targetEntityId"
                                        @update:value="onEntityChange('category', $event)"
                                />
                                <p v-if="resolvedEntityUrl" class="scop-platform-redirect-details__entity-hint">
                                    {{ $tc('scopplatformredirecter.detail.resolvedSeoUrlHint') }}
                                    <code>{{ resolvedEntityUrl }}</code>
                                </p>
                            </template>
                        </template>
                    {% endblock %}

                    <sw-select-number-field :label="$t('scopplatformredirecter.detail.httpCodeLabel')"
                                            v-model:value="redirect.httpCode" validation="required" @update:value="transformHttpCodeValueToNumber">
                        <option value=301>{{ $t('scopplatformredirecter.detail.httpCodeLabelValues.301') }}</option>
                        <option value=302>{{ $t('scopplatformredirecter.detail.httpCodeLabelValues.302') }}</option>
                    </sw-select-number-field>
                    <sw-switch-field :label="$tc('scopplatformredirecter.detail.enabledLabel')"
                                     v-model:value="redirect.enabled" validation="required"></sw-switch-field >
                    <sw-select-number-field :label="$t('scopplatformredirecter.detail.queryParamsHandling')"
                                            v-model:value="redirect.queryParamsHandling" validation="required" @update:value="transformQueryFieldValueToNumber">
                        <option value=0>{{ $t('scopplatformredirecter.detail.queryParamsHandlingValues.consider') }}</option>
                        <option value=1>{{ $t('scopplatformredirecter.detail.queryParamsHandlingValues.ignore') }}</option>
                        <option value=2>{{ $t('scopplatformredirecter.detail.queryParamsHandlingValues.transfer') }}</option>
                    </sw-select-number-field>

                    <sw-entity-single-select v-model:value="redirect.salesChannelId" entity="sales_channel" :resetOption="$t('scopplatformredirecter.detail.salesChannel.all')" :label="$t('scopplatformredirecter.detail.salesChannel.select')"></sw-entity-single-select>
                </sw-card>
            </sw-card-view>
        </template>
    </sw-page>
{% endblock %}
